
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
import Carousel from "@/components/Home/Carousel.vue";
import DemoSwiper from "@/components/Home/MobileSwiper.vue";
import EnterprisePartner from "@/components/Academy/Utility/EnterprisePartner.vue";
import TigerSchoolFootBanner from "@/components/Academy/Utility/TigerSchoolFootBanner.vue";

@Component({
  components: {
    Carousel,
    DemoSwiper,
    EnterprisePartner,
    TigerSchoolFootBanner
  },
})
export default class AcademyPage extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "師虎學院｜零基礎修繕技術培訓課程",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "師虎學院結合政府與企業資源，提供系統化修繕技術訓練，即使零經驗也能學習一技之長、成為專業師傅，提高就業與接案競爭力。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "師虎學院｜零基礎修繕技術培訓課程",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "師虎學院結合政府與企業資源，提供系統化修繕技術訓練，即使零經驗也能學習一技之長、成為專業師傅，提高就業與接案競爭力。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/Academy",
        },
      ],
    };
  }

  device = 2;
  footbannerOption = {
    btnText: "企業合作",
    // linkUrl: "/Academy/EnterpriseEnquire",
    linkUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdEtMMu8a2Qm_lOajFOjDSNfcNiVJRZI7NKGhjJ3xape_spaw/viewform?usp=sf_link",
    cssProps: {
      backgroundImage: `url(${require("@/assets/banner/academy.jpg")})`,
    },
  };
}
